import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { OutgoingGeneralContent, OutgoingTransactionGeneral } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemOutgoingTransaction from '../hooks/use-outgoing';

const ProblemOutgoingGeneralContentHOC = (): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.outgoing,
  );
  const { pspAccounts, overdraftEnabled } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList, paymentTypes } = useAppSelector(
    (state) => state.root,
  );

  const { transactionId } = useParams();

  const {
    getAccountBalanceAction,
    balanceIsLoading,
    pspPartnerBalanceisLoading,
    balanceIsFetching,
    pspPartnerBalanceisFetching,
    accountBalance,
    pspPartnerAccountBalance,
    balances,
    pspPartnerAccountBalanceInfo,
  } = useProblemOutgoingTransaction({
    transactionId,
    transaction,
    pspAccounts,
  });

  useEffect(() => {
    if (transaction) {
      getAccountBalanceAction();
    }
  }, [transaction]);

  return (
    <OutgoingGeneralContent
      general={transaction as OutgoingTransactionGeneral}
      transactionUrlType="outgoing"
      transactionId={transactionId}
      currenciesList={currenciesList}
      currencyName={transaction?.currency?.name}
      withTransactionUrl
      isLoading={
        balanceIsLoading ||
        pspPartnerBalanceisLoading ||
        balanceIsFetching ||
        pspPartnerBalanceisFetching
      }
      accountBalance={accountBalance}
      pspPartnerAccountBalance={pspPartnerAccountBalance}
      pspPartnerName={
        pspAccounts?.find(
          (item) => item.pspPartner.id === transaction?.pspPartnerId,
        )?.pspPartner.companyName
      }
      paymentsTypes={paymentTypes?.map((item) => ({
        name: item.name,
        value: item.paymentType,
      }))}
      overdraftEnabled={overdraftEnabled}
      senderAccounts={[
        {
          name: transaction?.senderAccount?.description,
          value: transaction?.senderAccount?.fullNumber,
          suffix: transaction?.senderAccount?.fullNumber,
        },
      ]}
      senderAccountsWithInfo={[transaction?.senderAccount]}
      balances={balances}
      currencies={currenciesList?.map((item) => ({
        name: item.name,
        value: item.id,
      }))}
      currencyId={transaction?.currencyId}
      pspPartnersAccountsList={pspAccounts}
      pspPartnerAccountBalanceInfo={pspPartnerAccountBalanceInfo}
    />
  );
};

export default ProblemOutgoingGeneralContentHOC;
